export enum OverpaymentUnderpaymentTypeEnum {
  OverpaymentUnderpaymentTypeOneTime = 'OVERPAYMENT_UNDERPAYMENT_TYPE_ONE_TIME',
  OverpaymentUnderpaymentTypeRecurring = 'OVERPAYMENT_UNDERPAYMENT_TYPE_RECURRING',
}
